module.exports = __webpack_public_path__ + "img/museu-marechal-jose-machado.5cb99308.jpg";